(function() {
    window.c24.lp.ac.rlv = {

        init: function() {

            window.c24.lp.ac.addDefaultQtips('rlv');

            window.c24.lp.ac.addQTip({
                acType: 'rlv',
                hoverElement: '.box24TeaserInfo',
                toolTipChild: '.js24Tooltip',
                arrowPosition: 'top center',
                parentPosition: 'bottom center',
                viewport: $(window),
            });

            window.addEventListener('click', function(e) {
                if (e.target.tagName === 'BUTTON' && e.target.closest('.c24rlvInfoTooltipButton')) {
                    document.querySelector('.mod24ac.rlv form')?.submit();
                }

                if (e.target.tagName === 'SPAN' && e.target.parentElement.classList.contains('rlvInfo')) {
                    window._paq.push([
                        'trackEvent',
                        window.c24Lp.getMatomoEventCategory(),
                        'rlvInfoTooltip',
                        'desktop',
                    ]);
                }
            });
        },
    };

    const elements = document.querySelectorAll('.mod24ac.rlv .widget');

    for (let i = 0; i < elements.length; i++) {
        const oError = {
            'notValid': 'Bitte geben Sie ein gültiges Geburtsdatum ein.',
            'age': {
                'min': 'Leider können unter 18 Jahre alte Personen keine Risikolebensversicherung abschließen',
                'max': 'Das Eintrittsalter für eine Risikolebensversicherung darf zum Jahresende höchstens 75 Jahre betragen',
            },
            'leapYear': 'Angegebene Jahr ist kein Schaltjahr',
            'inFuture': 'Datum liegt in der Zukunft',
            'generic': 'Es ist ein Fehler aufgetreten',
        };
        $(elements[i]).c24TeaserDateWidget(oError);
    }

    $(document).ready(function() {
        window.c24.lp.ac.rlv.init();
    });
})();
